import React from 'react';
import { copyToClipboard } from './popupUtils';
import { safeHref, NOTES_MAX_CHARS } from '../../Common.js';
import { toast } from 'react-toastify';

const PopupAliasForm = ({ 
    mode, // 'create' or 'edit'
    user,
    siteName,
    setSiteName,
    siteUrl,
    setSiteUrl,
    privateNotes,
    setPrivateNotes,
    alertsEnabled,
    setAlertsEnabled,
    hidden,
    setHidden,
    handleSpamBy,
    setHandleSpamBy,
    editingAlias,
    creating,
    saving,
    onSave,
    onCancel
}) => {
    const isEdit = mode === 'edit';
    const isLoading = creating || saving;
    const pageName = isEdit ? 'Edit Alias' : 'New Alias';
    const saveButtonText = isEdit ? 
        (saving ? 'Saving...' : 'Save') : 
        (creating ? 'Creating...' : 'Save');

    const handleAliasCopy = () => {
        if (editingAlias) {
            copyToClipboard(`${editingAlias.alias}@nslmail.com`, toast.success);
        }
    };

    return (
        <div className="popup-container">
            <div className="popup-header">
                <img src="/images/nslmail_sm.gif" alt="NslMail" className="popup-header-logo" />
                <span className="popup-header-page-name">{pageName}</span>
                {isEdit && editingAlias && (
                    <span 
                        className="popup-header-alias"
                        onClick={handleAliasCopy}
                        title="Click to copy to clipboard"
                    >
                        {editingAlias.alias}@nslmail.com
                    </span>
                )}
                <span className="popup-header-greeting">Hello, {user?.first_name}</span>
            </div>
            
            <div className="popup-content-padding">
                
                <div className="popup-form-group">
                    <label className="popup-form-label">
                        Site Name
                    </label>
                    <input 
                        type="text" 
                        value={siteName}
                        onChange={(e) => setSiteName(e.target.value)}
                        className="popup-form-input"
                        required
                    />
                </div>
                
                <div className="popup-form-group">
                    <label className="popup-form-label">
                        Site URL
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                        <input 
                            type="text" 
                            value={siteUrl}
                            onChange={(e) => setSiteUrl(e.target.value)}
                            className="popup-form-input"
                            style={{ flex: 1 }}
                            required
                        />
                        <button 
                            type="button"
                            style={{ 
                                background: 'none',
                                border: 'none',
                                padding: '4px',
                                cursor: safeHref(siteUrl) ? 'pointer' : 'default',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: safeHref(siteUrl) ? 1 : 0.5
                            }}
                            onClick={() => {
                                // siteUrl arrives from this page's ?url= parameter,
                                // which anyone can put in a link. See safeHref.
                                const href = safeHref(siteUrl);
                                if (href) {
                                    window.open(href, '_blank', 'noopener,noreferrer');
                                }
                            }}
                            aria-label="Open site URL in new tab"
                            disabled={!safeHref(siteUrl)}
                        >
                            <img 
                                src="/images/external.png" 
                                alt="Open link" 
                                style={{ width: '16px', height: '16px' }}
                            />
                        </button>
                    </div>
                </div>
                
                
                <div className="popup-form-group">
                    <label className="popup-form-label">
                        Private Notes
                    </label>
                    <textarea 
                        rows="4"
                        maxLength={NOTES_MAX_CHARS}
                        value={privateNotes}
                        onChange={(e) => setPrivateNotes(e.target.value)}
                        className="popup-form-textarea"
                    />
                </div>
                
                <div className="popup-form-group">
                    <label className="popup-form-label">
                        Handle spam by
                    </label>
                    <select 
                        className="popup-form-select"
                        value={handleSpamBy}
                        onChange={(e) => setHandleSpamBy(parseInt(e.target.value))}
                    >
                        <option value={-1}>Use Global Setting</option>
                        <option value={0}>Prefixing Subject Line</option>
                        <option value={1}>Deleting Message</option>
                    </select>
                </div>
                
                <div className="popup-form-checkbox-group">
                    <label className="popup-form-checkbox-label">
                        <input 
                            type="checkbox" 
                            checked={alertsEnabled}
                            onChange={(e) => setAlertsEnabled(e.target.checked)}
                        />
                        Alert me of held messages
                    </label>
                    <label className="popup-form-checkbox-label">
                        <input 
                            type="checkbox"
                            checked={hidden}
                            onChange={(e) => setHidden(e.target.checked)}
                        />
                        Hide from main view
                    </label>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                    <button 
                        onClick={onSave}
                        disabled={isLoading}
                        className="popup-primary-button"
                    >
                        {saveButtonText}
                    </button>
                    <button 
                        onClick={onCancel}
                        className="popup-secondary-button"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupAliasForm;